import React from 'react';
import "./Post.css";
import { ThreeDotsVertical } from 'react-bootstrap-icons';

import { useState } from "react";
import per from '../../../assets/person/1.jpeg';
import Like from '../../../assets/post/like.png';
import heart from '../../../assets/post/heart.png';


function Post({ post }) {

  const [like, setLike] = useState(post.like)
  const [isLiked, setIsLiked] = useState(false)

  const likeHandler = () => {
    setLike(isLiked ? like - 1 : like + 1)
    setIsLiked(!isLiked)
  }

  const Users = [
    {
      id: 1,
      profilePicture: per,
      username: "Safak Kocaoglu",
    },
    {
      id: 2,
      profilePicture: per,
      username: "Janell Shrum",
    },
    {
      id: 3,
      profilePicture: per,
      username: "Alex Durden",
    },
    {
      id: 4,
      profilePicture: per,
      username: "Dora Hawks",
    },
    {
      id: 5,
      profilePicture: per,
      username: "Thomas Holden",
    },
    {
      id: 6,
      profilePicture: per,
      username: "Shirley Beauchamp",
    },
    {
      id: 7,
      profilePicture: per,
      username: "Travis Bennett",
    },
    {
      id: 8,
      profilePicture: per,
      username: "Kristen Thomas",
    },
    {
      id: 9,
      profilePicture: per,
      username: "Gary Duty",
    },
    {
      id: 10,
      profilePicture: per,
      username: "Safak Kocaoglu",
    },
  ];


  return (
    <div className="post">
      <div className="postWrapper">

        <div className="postTop">
          <div className="postTopLeft">
            <img
              className="postProfileImg"
              src={Users.filter((u) => u.id === post?.userId)[0].profilePicture}
              alt=""
            />
            <span className="postUsername">
              {Users.filter((u) => u.id === post?.userId)[0].username}
            </span>
            <span className="postDate">{post.date}</span>
          </div>
          <div className="postTopRight">
            <ThreeDotsVertical />
          </div>
        </div>

        <div className="postCenter">
          <span className="postText">{post?.desc}</span>
          <img className="postImg" src={post.photo} alt="" />
        </div>

        <div className="postBottom">
          <div className="postBottomLeft">
            <img className="likeIcon" src={Like} onClick={likeHandler} alt="" />
            <img className="likeIcon" src={heart} onClick={likeHandler} alt="" />
            <span className="postLikeCounter">{like} people like it</span>
          </div>
          <div className="postBottomRight">
            <span className="postCommentText">{post.comment} comments</span>
          </div>
        </div>

        <div className="postBottom">
          <div className="comments-comment-box-comment__text-editor">
            <div>
              <div className="editor-container relative">
                <div>
                  <div className="editor-content ql-container">
                    <input className="ql-editor ql-blank" type="text" name="Text editor for creating content" placeholder={"Type your comments here ... "} />
                    <div className="ql-clipboard" contenteditable="true" tabindex="-1">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Post
